import { client } from './client';

export async function fetchArticles() {
  return client.fetch(`*[_type == "article"] | order(publishedAt desc) {
    _id,
    title,
    slug,
    excerpt,
    publishedAt,
    coverImage,
    author
  }`);
}

export async function fetchArticleBySlug(slug: string) {
  return client.fetch(`*[_type == "article" && slug.current == $slug][0] {
    _id,
    title,
    slug,
    excerpt,
    publishedAt,
    coverImage,
    author,
    body
  }`, { slug });
} 